import wsMapping from "../constants/wsMapping";

export const translateWeather = (ws = []) =>
  ws.map((value) => wsMapping[value] || "نامشخص");

export default translateWeather;
